const MAX_PREVIEW_LINES = 15;

export const httpStatusText = (code: number): string => {
  const statusTexts: Record<number, string> = {
    200: 'OK',
    201: 'Created',
    204: 'No Content',
    400: 'Bad Request',
    401: 'Unauthorized',
    403: 'Forbidden',
    404: 'Not Found',
    409: 'Conflict',
    422: 'Unprocessable Entity',
    429: 'Too Many Requests',
    500: 'Internal Server Error',
    502: 'Bad Gateway',
    503: 'Service Unavailable',
  };
  return statusTexts[code] ?? '';
};

export const statusClassName = (code: number): string => {
  if (code >= 200 && code < 300) return 'text-primary fw-semibold';
  if (code >= 500) return 'text-danger fw-semibold';
  return 'text-warning fw-semibold';
};

export const formatJson = (value: string | null): string => {
  if (!value) return '—';
  try {
    return JSON.stringify(JSON.parse(value), null, 2);
  } catch {
    return value;
  }
};

export const clipJson = (value: string | null): { preview: string; remaining: number } => {
  const formatted = formatJson(value);
  const lines = formatted.split('\n');
  if (lines.length <= MAX_PREVIEW_LINES) return { preview: formatted, remaining: 0 };
  return {
    preview: lines.slice(0, MAX_PREVIEW_LINES).join('\n'),
    remaining: lines.length - MAX_PREVIEW_LINES,
  };
};

export const formatTimestamp = (timestamp: string) =>
  new Date(timestamp).toLocaleString('en-US', {
    month: '2-digit',
    day: '2-digit',
    year: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
  });
